import Logger from "./../services/logger";
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";

import { ALL_CLIENT_CODE } from "./../util/constants";
import BaseConfiguration from "./../config/base";
import store from "../store";





export function getBaseURL() {
  let retValue;
    try {
      if(BaseConfiguration.isDebug) console.log("getBaseURL");
      retValue=  process.env.VUE_APP_BASE_URL

    } catch (err) {
            let body = Logger.buildRequest(
              FILE_NAME.ENV_CONFIG,
              "error in getBaseURL",
              err.toString(),
              "getBaseURL",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
      return retValue;
    }

export function getClientCode() {
    let retValue;
    try {
      if(BaseConfiguration.isDebug) console.log("getClientCode");


        retValue=  process.env.VUE_APP_CLIENTCODE
  

    } catch (err) {
            let body = Logger.buildRequest(
              FILE_NAME.ENV_CONFIG,
              "error in getClientCode",
              err.toString(),
              "getClientCode",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
      return retValue;
    }



export     function getPaymentURL() {
        let retValue = null;
        try{
            if(BaseConfiguration.isDebug) console.log("getPaymentURL");
          if(process.env.VUE_APP_IS_DEBUG==true){
            switch (process.env.VUE_APP_CLIENTCODE) {
              case ALL_CLIENT_CODE.MF:
                retValue = "http://dev.b2b.ascent24.io";
                break;
              case ALL_CLIENT_CODE.AZ:
                  retValue = "https://az.b2b.ascent24.io";
                break;
              default:
                retValue = null;
                break;
            }
          }
        }
        catch(err)
        {
            let body = Logger.buildRequest(
                FILE_NAME.ENV_CONFIG,
                "error in getPaymentURL",
                err.toString(),
                "getPaymentURL",
                LOG_TYPE.ERROR
              );
              Logger.getResponse(body);
            }
            return retValue;
        }
         
      
    
export function   isDebugMode() {
    let retValue;
    try {
     

        retValue= JSON.parse( process.env.VUE_APP_IS_DEBUG)
  

    } catch (err) {
            let body = Logger.buildRequest(
              FILE_NAME.ENV_CONFIG,
              "error in isDebugMode",
              err.toString(),
              "isDebugMode",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
      return retValue;
    }


  /*   export function getVersion() {
        let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getVersion");
          
       // retValue=process.env.VUE_APP_VERSION
   
         
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.ENV_CONFIG,
                  "error in getVersion",
                  err.toString(),
                  "getVersion",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        } */


        export function getMFOrgId() {
            let retValue;
            try {
              if(BaseConfiguration.isDebug) console.log("getMFOrgId");
            
              retValue=  process.env.VUE_APP_MF_ORGID
            } catch (err) {
                    let body = Logger.buildRequest(
                      FILE_NAME.ENV_CONFIG,
                      "error in getMFOrgId",
                      err.toString(),
                      "getMFOrgId",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
              return retValue;
            } 

            export function getAZOrgId() {
                let retValue;
                try {
                  if(BaseConfiguration.isDebug) console.log("getAZ.OrgId");
                 
                  retValue=  process.env.VUE_APP_AZ_ORGID
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.ENV_CONFIG,
                          "error in getAZ.OrgId",
                          err.toString(),
                          "getAZ.OrgId",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
                }


                export function getSubscriptionURL() {
                    let retValue;
                    try {
                      if(BaseConfiguration.isDebug) console.log("getSubscriptionURL");
                 retValue=process.env.VUE_APP_SUBSCRIPTION_URL;
                
                    } catch (err) {
                            let body = Logger.buildRequest(
                              FILE_NAME.ENV_CONFIG,
                              "error in getSubscriptionURL",
                              err.toString(),
                              "getSubscriptionURL",
                              LOG_TYPE.ERROR
                            );
                            Logger.getResponse(body);
                          }
                      return retValue;
                    }